import { Navigate, Outlet } from 'react-router-dom-v5-compat';

import { ROLE_LEVELS, useAuthLevel } from '../../hooks/useCurrentUser';

// Manager+ gate for the Inventar section. `level === undefined` means auth is
// still hydrating — render a loader, never redirect (refreshes would bounce).
export default function InventoryGate() {
    const level = useAuthLevel();
    if (level === undefined) {
        return (
            <div className="flex h-64 w-full items-center justify-center text-sm text-gray-500 dark:text-gray-400">
                Se incarca...
            </div>
        );
    }
    if (level < ROLE_LEVELS.MANAGER) return <Navigate to="/v2/dashboard" replace />;
    return <Outlet />;
}
